import { render, staticRenderFns } from "./imageText.vue?vue&type=template&id=faa3185e&scoped=true"
import script from "./imageText.vue?vue&type=script&lang=js"
export * from "./imageText.vue?vue&type=script&lang=js"
import style0 from "./imageText.vue?vue&type=style&index=0&id=faa3185e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa3185e",
  null
  
)

export default component.exports